/**
 * Composant tampon de detection de visibilite.
 *
 * Reproduit l'API de `react-visibility-sensor` (abandonnee) au-dessus de
 * `react-intersection-observer` (maintenu, base sur IntersectionObserver natif). Seule la surface
 * utilisee dans le projet est reproduite: children (noeud), `onChange(isVisible)`, `active`.
 * Les consommateurs importent d'ici, si bien qu'un futur changement ne touchera que ce fichier.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { InView } from 'react-intersection-observer';

function VisibilitySensor({ children, onChange, active = true, ...props }) {
    return (
        <InView
            as="span"
            skip={!active}
            onChange={inView => onChange && onChange(inView)}
            {...props}
        >
            {children}
        </InView>
    );
}

VisibilitySensor.propTypes = {
    children: PropTypes.node,
    onChange: PropTypes.func,
    active: PropTypes.bool,
};

export default VisibilitySensor;
